import * as actionTypes from 'constants/actionTypes';

export function updateChecklist(checklistId, changes) {
  return {
    type: actionTypes.UPDATE_CHECKLIST,
    payload: {
      checklistId,
      changes,
    },
  };
}

export function createChecklist() {
  return {
    type: actionTypes.CREATE_CHECKLIST,
  };
}

export function addItemToChecklist(checklistId, shouldOpenModal = false) {
  return {
    type: actionTypes.ADD_ITEM_TO_CHECKLIST,
    payload: {
      checklistId,
      shouldOpenModal,
    },
  };
}

export function removeItemFromChecklist(
  checklistId,
  checklistItemId,
  checklistItems
) {
  return {
    type: actionTypes.REMOVE_ITEM_FROM_CHECKLIST,
    payload: {
      checklistId,
      checklistItemId,
      checklistItems,
    },
  };
}

export function reorderChecklistItems(
  itemId1,
  newIndex1,
  itemId2,
  newIndex2,
  checklistId
) {
  return {
    type: actionTypes.REORDER_CHECKLIST_ITEMS,
    payload: {
      itemId1,
      newIndex1,
      itemId2,
      newIndex2,
      checklistId,
    },
  };
}

export function calculateChecklistItemDependencies(
  checklistId,
  checklistItems
) {
  return {
    type: actionTypes.CALCULATE_CHECKLIST_ITEM_DEPENDENCIES,
    payload: {
      checklistId,
      checklistItems,
    },
  };
}

export function updateChecklistItemAndFlushChecklist(
  checklistId,
  checklistItemId,
  changes
) {
  return {
    type: actionTypes.UPDATE_CHECKLIST_ITEM_AND_FLUSH_CHECKLIST,
    payload: {
      checklistId,
      checklistItemId,
      changes,
    },
  };
}

export function deleteChecklist(checklistId) {
  return {
    type: actionTypes.DELETE_CHECKLIST,
    payload: {
      checklistId,
    },
  };
}

export function cloneChecklist(checklistId) {
  return {
    type: actionTypes.CLONE_CHECKLIST,
    payload: {
      checklistId,
    },
  };
}
